import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

const todayStart = dayjs().startOf('day').toISOString();
const todayEnd = dayjs().endOf('day').toISOString();

const initialState = {
  customerOrdersPagination: {
    current: 1,
    pageSize: 20,
  },
  searchText: '',
  filterReference: '',
  filterStatus: null,

  orderDateRange: [todayStart, todayEnd],
  deliveryDateRange: [null, null],

  dateFilterType: 'order', // 'order' | 'delivery'
};

const customerOrdersFiltersSlice = createSlice({
  name: 'customerOrdersFilters',
  initialState,
  reducers: {
    setCustomerOrdersPagination: (state, action) => {
      state.customerOrdersPagination = action.payload;
    },
    setCustomerOrdersSearchText: (state, action) => {
      state.searchText = action.payload;
    },
    setCustomerOrdersFilterReference: (state, action) => {
      state.filterReference = action.payload;
    },
    setCustomerOrdersFilterStatus: (state, action) => {
      state.filterStatus = action.payload;
    },
    setCustomerOrdersOrderDateRange: (state, action) => {
      state.orderDateRange = action.payload;
    },
    setCustomerOrdersDeliveryDateRange: (state, action) => {
      state.deliveryDateRange = action.payload;
    },
    setCustomerOrdersDateFilterType: (state, action) => {
      state.dateFilterType = action.payload;
    },
    resetCustomerOrdersFilters: () => initialState,
  },
});

export const {
  setCustomerOrdersPagination,
  setCustomerOrdersSearchText,
  setCustomerOrdersFilterReference,
  setCustomerOrdersFilterStatus,
  setCustomerOrdersOrderDateRange,
  setCustomerOrdersDeliveryDateRange,
  setCustomerOrdersDateFilterType,
  resetCustomerOrdersFilters,
} = customerOrdersFiltersSlice.actions;

export default customerOrdersFiltersSlice.reducer;